export default "/images/ec4707fc9c1637a855fc1f38404ba4e5.avif";